import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=6757b5e5&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757b5e5",
  null
  
)

export default component.exports